import styled from 'styled-components';
import { Form } from 'antd';

export const FormContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const FormColumn = styled.div`
  padding: 20px;
`;

export const FormGroupTite = styled.p`
  font-size: 21px;
  margin: 15px 0 0 0;
`;

export const FormItem = styled(Form.Item)`
  &.business-name-form-item,
  &.google-place-id-form-item {
    .ant-form-explain {
      font-size: smaller;
      color: rgb(239, 0, 0);
    }

    .ant-form-item-children-icon {
      top: 16px;
    }
  }
  &.google-place-id-form-item a {
    color: rgb(239, 0, 0);
    text-decoration: underline;
  }
  margin: 0;
  .ant-form-item-label {
    padding: 0;
    label {
      color: #676a6c;
    }
  }
  button {
    margin: 20px;
  }

  .ant-form-item-children {
    position: static;
  }
`;

export const HR = styled.hr`
  margin: 0;
  margin-bottom: 20px;
`;

export const LookupContainer = styled.p`
  margin: 10px 0;
`;

export const AddressContainer = styled.p`
  pointer-events: none !important;
  background-color: rgba(100, 100, 100, 0.2);
  padding: 20px;
`;
